// ----------------------------------------- ALL VARIABLES ----------------------------------------- //
window.stonePlacementHistory = [];
const svg_classes = ['icon-cst-dia','icon-cst-zo','icon-cst-cc'],
      engraving_btn = document.querySelector('[data-engraving-start]'), // Engraving start button
      engraving_wrapper = document.querySelector('[data-engraving-wrap]'), // Engraving Main wrapper
      engraving_bar = document.querySelector('[data-engraving-bar]'), // Engraving Steps bar
      engraving_image = document.querySelector('[data-custom-image]'), // Engraving Image
      step_wrappers = document.querySelectorAll('[data-step-wrapper]'), // All Steps wrapper
      step_wrappers_description = document.querySelectorAll('[data-engraving_description]'), // All Steps wrapper
      engraving_next = document.querySelector('[data-engraving-next]'), // Next step button
      engraving_prev = document.querySelector('[data-engraving-prev]'), // Prev step button
      engraving_error = document.querySelector('[data-engraving-error]'), // Engraving error
      max_limit = engraving_wrapper.getAttribute('data-max_selection'), // Max spot selection for engraving
      cosmos_type = engraving_wrapper.dataset.cosmosType, // Engraving type: 'Pendant / Ring'
      main_product_id = engraving_wrapper.dataset.mainProduct, // Get the Main product ID
      main_product_title = engraving_wrapper.dataset.mainProductTitle, // Get the Main product Title
      center_stone = engraving_wrapper.querySelector('[data-pendant-center]'), // Center stone on Pendant
      engraving_price = engraving_wrapper.querySelector('[data-engraving-price]'), // Total price
      all_stone_inputs = document.querySelectorAll('.pendant_content_inn:not(.pendant_color)'), // All input buttons except for color/pendant
      allSlots = Array.from(document.querySelectorAll('[id^="slot-"], [id^="main-slot-"]')).filter(el => /^(slot|main-slot)-\d+$/.test(el.id)), // All slots on the SVG
      engraving_popup = document.querySelector('[data-engaving-popup]'), // POPUP Selector
      popup_title = engraving_popup?.querySelector('[data-popup-title]'), // POPUP Title
      popup_desc = engraving_popup?.querySelector('[data-popup-description]'), // POPUP Desc
      popup_close = engraving_popup?.querySelectorAll('[data-close-popup]'), // popup close button
      slot_empty_popup_btn = engraving_popup?.querySelector('[data-empty-slot]'), // empty slot confirm POPUP button
      skip_to_next_step = engraving_popup?.querySelectorAll('[data-skip-popup]'), // move to next step POPUP button
      checkout_btn = document.querySelector('[data-proceed-checkout]'),
      cosmos_stone_info = document.querySelector('.pendant_stone_info'),
      cosmos_line_property = document.querySelector('[name="cosmos-properties"]'); // checkout button

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% Default HELPERS %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% 
// ----------------------------------------- COSMOS MAIN IMAGE SLIDER ----------------------------------------- //
const cosmos_slider = new Swiper(".pendant_slider", {
  slidesPerView: 'auto',
  spaceBetween: 0,
  pagination: {
    el: ".swiper-pagination.pendant_pagination",
    clickable: true,
  },
  navigation: {
      nextEl: ".swiper-button-next.pendant_arrow",
      prevEl: ".swiper-button-prev.pendant_arrow",
  }
});

// ----------------------------------------- SCROLL TO VIEW ----------------------------------------- //
const scrollToView = ($ele) => {
  $ele.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// ----------------------------------------- HANDLE ERROR MESSAGE FOR ALL EVENTS ----------------------------------------- //
const handleErrorMessage = (msg = '') => {
  if (msg === '') {
    engraving_error.classList.add('hide'), engraving_error.textContent = '';
  } else {
    engraving_error.textContent = msg, engraving_error.classList.remove('hide');
  }
}

// ----------------------------------------- REMOVE OTHER STONE TYPE CLASS FROM ALL THE SLOTS ----------------------------------------- //
const updateSVGClass = ($slot, svg_class) => {
  if (!$slot) return;

  svg_classes.forEach(cls => $slot.classList.remove(cls));
  $slot.classList.add(svg_class);
}

// ----------------------------------------- RESET SLOTS WHEN NEXT/PREV/SKIP POPUP ----------------------------------------- //
const resetSlots = () => {
  const unfilledSlots = getUnfilledSlots();
  unfilledSlots.forEach(el => el.classList.remove('glow-on'));
  step_wrappers.forEach(el => el.classList.remove('stone-zoomin-active'));
  delete window.inputQuantityClicked;
}

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% STEPS AND PROGRESS BAR HELPERS %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
// ----------------------------------------- GET CURRENT INDEX ----------------------------------------- //
const getCurrentStepIndex = () => {
  return Array.from(step_wrappers).findIndex(step => step.classList.contains('step-active'));
}

// ----------------------------------------- UPDATE PROGRESS BAR FOR THE ACTIVE STATE ----------------------------------------- //
const updateProgressBar = (currentIndex) => {
  engraving_bar.querySelectorAll('.circle').forEach((circle, i) => {
    if (i === currentIndex) {
      circle.classList.add('active');
      circle.classList.remove('clicked');
      step_wrappers_description.forEach(el => el.classList.remove('d-active'));
      step_wrappers_description[currentIndex].classList.add('d-active');
    } else if (i > currentIndex) {
      circle.classList.remove('active', 'clicked');
    } else {
      circle.classList.remove('active');
      circle.classList.add('clicked');
    }
  });
}

// ----------------------------------------- ABONDON STEPS IF ANY INPUT IS ACTIVE BUT NOT PLACED ON SPOT ----------------------------------------- //
const abandonSteps = ($selectedStep) => {
  const allInputs = $selectedStep.querySelectorAll('input[type="checkbox"]');
  const unplaced = Array.from(allInputs).filter(input =>
    input.checked &&
    input.parentElement.classList.contains('is-active') &&
    !input.parentElement.classList.contains('is-chosen')
  ), 
  selectedSlots = Array.from(allSlots).filter(slot => 
    slot.classList.contains('active')
  );

  if (unplaced.length > 0) {
    handleErrorMessage($selectedStep.querySelector('.zodiac-icon') ? theme.engraving.sign_placement_required_error : theme.engraving.placement_required_error);
    return false;
  }

  if (selectedSlots.length > 0) {
    handleErrorMessage($selectedStep.querySelector('.zodiac-icon') ? theme.engraving.sign_slot_selected_error : theme.engraving.slot_selected_error);
    return false;
  }

  return true;
}

// ----------------------------------------- CHANGE STEPS ----------------------------------------- //
const showStep = (index, scroll = false) => {
  const final_step = totalSteps = step_wrappers.length - 1;

  checkout_btn.style.display = 'none';
  engraving_next.style.display = 'block';

  step_wrappers.forEach((step, i) => {
    step.classList.toggle('step-active', i === index);
    if (final_step == index) {
      checkout_btn.style.display = 'block';
      engraving_next.style.display = 'none';
    }
  });
  updateProgressBar(index);
  resetSlots();
}

// ----------------------------------------- VALIDATE STEP FUNCTION COMMON FOR NEXT AND STEP CLICK ----------------------------------------- //
const validateCurrentStep = (currentIndex) => {
  const totalSteps = step_wrappers.length;
  const currentStep = step_wrappers[currentIndex];

  if (!abandonSteps(currentStep)) return false;

  // === STEP 1 VALIDATION ===
  if (currentIndex === 0) {
    const selectedColor = Array.from(document.querySelectorAll('input[type="radio"]:checked')).filter(input => /^color-type-\d+$/.test(input.name));
    const pendantTypeInputs = Array.from(document.querySelectorAll('input[type="radio"]')).filter(input => /^pendant-type-\d+$/.test(input.name));
    const selectedPendant = Array.from(document.querySelectorAll('input[type="radio"]:checked')).filter(input => /^pendant-type-\d+$/.test(input.name));

    if (pendantTypeInputs.length > 0 && selectedPendant.length === 0 && selectedColor.length === 0) {
      showErrorPopup('', theme.engraving.required_option_error);
      return false;
    }
    if (pendantTypeInputs.length > 0 && selectedPendant.length === 0) {
      showErrorPopup('', theme.engraving.pendant_type_error, true);
      return false;
    }
    if (selectedColor.length === 0) {
      showErrorPopup('', theme.engraving.color_error, );
      return false;
    }
  }

  // === STONE-INPUT VALIDATION (steps 2 to n-1) ===
  if (currentIndex > 0 && currentIndex < totalSteps - 1) {
    const hasStoneIcon = currentStep.querySelector('.stone-icon'),
          hasDiamondIcon = currentStep.querySelector('.diamond-icon'),
          hasZodiacIcon = currentStep.querySelector('.zodiac-icon');
    if (hasStoneIcon) { // no center stone selected
      const inputs = currentStep.querySelectorAll('input[type="radio"]');
      const anyChecked = Array.from(inputs).some(input => input.checked);
      if (!anyChecked) {
        showErrorPopup('', theme.engraving.stone_error);
        return false;
      }
    } else if (hasDiamondIcon) { // no diamond selected
      const inputs = currentStep.querySelectorAll('input[type="checkbox"]');
      const anyChecked = Array.from(inputs).some(input => input.checked);
      if (!anyChecked) {
        showErrorPopup('', theme.engraving.no_diamond_selection);
        engraving_popup.classList.add('step-confirm-popup-active');
        return false;
      }
    } else if (hasZodiacIcon) { // no zodiac selected
      const inputs = currentStep.querySelectorAll('input[type="checkbox"]');
      const anyChecked = Array.from(inputs).some(input => input.checked);
      if (!anyChecked) {
        showErrorPopup('', theme.engraving.no_zodiac_selection);
        engraving_popup.classList.add('step-confirm-popup-active');
        return false;
      }
    }
  }

  return true;
};

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% FINAL STEP %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
// ----------------------------------------- ADD ALL PRODUCTS TO CART ----------------------------------------- //
async function addCosmosToCart(responseData) {
  try {
    if (!responseData) {
      console.error('No response data provided');
      return false;
    }

    const properties = {
      _selected_color: Shopify.cosmos_data?.selected_color
    };

    Shopify.cosmos_data?.selected_stones?.forEach((stone, index) => {
      if (!stone) return;

      properties[`_stone_id_${index + 1}`] = stone.id;
      properties[`_stone_name_${index + 1}`] = stone.name;
      properties[`_stone_img_${index + 1}`] = stone.image;
      properties[`_stone_qty_${index + 1}`] = stone.quantity;
    });

    if (cosmos_line_property.value != '') properties['מידות / הערות / בקשות מיוחדות'] = cosmos_line_property.value;

    const formData =  {
      id: responseData.variant_id,
      quantity: 1,
      properties
    };

    const response = await fetch(`${theme.routes.cartAdd}?t=${Date.now()}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData),
    });
    
    if (!response.ok) {
      console.error('Fetch failed with status:', response.status);
      handleErrorMessage('Error adding to cart. Please try again later.');
      return;
    }

    const data = await response.json();

    console.log('Product Added to Cart: ', data);

    if (data.status === 422) {
      console.error('Cart add error (422):', data);
      handleErrorMessage(theme.engraving.api_error);
    } else {
      // const product = data;
      // document.dispatchEvent(
      //   new CustomEvent('ajaxProduct:added', {
      //     detail: {
      //       product: product,
      //       addToCartBtn: checkout_btn,
      //     },
      //   })
      // );
      // document.dispatchEvent(new CustomEvent('cart:build'));
      // requestAnimationFrame(() => {
      //   document.dispatchEvent(new CustomEvent('cart:build'));
      //   document.dispatchEvent(new CustomEvent('cart:open'));
      // });
      try {
        const html = await fetch(`${theme.routes.cartPage}?view=ajax&t=${Date.now()}`, {
          method: 'GET',
          credentials: 'same-origin'
        }).then(response => response.text());
        
        theme.cartDrawer = new theme.CartForm(document.querySelector('#CartDrawerForm'));
        theme.cartDrawer.cartMarkup(html);

        requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
      } catch (err) {
        console.error('Failed to rebuild cart drawer:', err);
      }
    }
  } catch (error) {
    console.log(error);
    console.error('Unexpected error in addCosmosToCart:', error);
    handleErrorMessage(theme.engraving.api_error);
  } finally {
    // Always reset button/loading state
    if (typeof status !== 'undefined') status.loading = false;
    checkout_btn?.classList.remove('btn--loading');
  }
}

async function generateCustomProduct() {
  console.log('Shopify cosmos data: ', Shopify.cosmos_data);
  try {
    const response = await fetch('https://my.she-ra-jewelry.com/api/generate-final-product.php', { 
        method: 'POST', 
        crossDomain: true,
        dataType:"json",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(Shopify.cosmos_data)
    });     
    
    if (!response.ok) {        
      throw new Error(`Failed to send POST request: ${response.status}`);
    }

    const responseData = await response.json();
    console.log('API response: ', responseData);
    
    if (response.error) {
      handleErrorMessage(response.error);
      return false;
    }

    if (!response.status && response.status != 'created') {
      handleErrorMessage(theme.engraving.api_error);
      return false;
    }

    await addCosmosToCart(responseData);
    console.log('Custom Product generated successfully!!!');
    
  } catch (error) {
    console.error('Error:', error);
  }
}

// ----------------------------------------- CLOUDINARY UPLOAD ----------------------------------------- //
async function uploadToCloudinary(blob) {
  const formData = new FormData();
  formData.append('upload_preset', 'doc_codepen_example');
  formData.append('tags', 'browser_upload');
  formData.append('file', blob);

  const response = await fetch('https://api.cloudinary.com/v1_1/demo/upload', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) throw new Error('Upload failed');
  return await response.json();
}

// ----------------------------------------- GENERATE ENGRAVING LIVE PREVIEW ----------------------------------------- //
async function generateImagePreview() {
  try {
    console.log('Generating engraving preview...');
    checkout_btn?.classList.add('btn--loading');

    // --- Step 1: Convert DOM to Blob (full quality) ---
    const blob = await domtoimage.toBlob(engraving_image, {
      quality: 1, // keep full quality
      style: {
        transform: 'scale(2)',
        transformOrigin: 'top left',
        width: engraving_image.offsetWidth + 'px',
        height: engraving_image.offsetHeight + 'px',
      },
      width: engraving_image.offsetWidth * 2,
      height: engraving_image.offsetHeight * 2,
    });

    console.log('Uploading preview image...');

    // --- Step 2: Upload to Cloudinary ---
    const uploadResult = await uploadToCloudinary(blob);
    if (!uploadResult?.secure_url) {
      throw new Error('Upload did not return a secure_url');
    }

    console.log('Preview image uploaded successfully!');
    Shopify.cosmos_data.feature_image = uploadResult.secure_url;

    // --- Step 3: Generate product + add to cart (can run together) ---
    console.log('Generating product and adding to cart...');
    await generateCustomProduct();

    // --- Step 4: Optional local download for user ---
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = 'engraving-preview.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    console.log('Done! Your custom item is being added to the cart.');

  } catch (error) {
    console.error('Error in generateImagePreview:', error);
    handleErrorMessage('An error occurred while creating your custom preview.');
  } finally {
    checkout_btn?.classList.remove('btn--loading');
  }
}

// // ----------------------------------------- GENERATE ENGRAVING LIVE PREVIEW ----------------------------------------- //
// const generateImagePreview = () => {
//   // DOM TO IMAGE using Cloudinary $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$  
//   let savedBlob = null;
//   domtoimage.toBlob(engraving_image, {
//     quality: 1,
//     style: {
//       transform: 'scale(2)',
//       transformOrigin: 'top left',
//       width: engraving_image.offsetWidth + 'px',
//       height: engraving_image.offsetHeight + 'px'
//     },
//     width: engraving_image.offsetWidth * 2,
//     height: engraving_image.offsetHeight * 2
//   })
//   .then(function (blob) {
//     const unsignedUploadPreset = 'doc_codepen_example', 
//           cloudinary_url = 'https://api.cloudinary.com/v1_1/demo/upload';
          
//     savedBlob = blob;

//     const formData = new FormData();
//     formData.append('upload_preset', unsignedUploadPreset);
//     formData.append('tags', 'browser_upload');
//     formData.append('file', blob);

//     return fetch(cloudinary_url, {
//       method: 'POST',
//       body: formData
//     });
//   })
//   .then(response => {
//     if (!response.ok) throw new Error('Upload failed');
//     return response.json();
//   })
//   .then(data => {
//     console.log('Preview Image created successfully!!!');
    
//     Shopify.cosmos_data.feature_image = data.secure_url;

//     // alert('Thanks for creating the custom product. Please wait while we process it to cart.');
//     generateCustomProduct();

//     // === DOWNLOAD the image once its ready ===
//     const downloadLink = document.createElement('a');
//     downloadLink.href = URL.createObjectURL(savedBlob);
//     downloadLink.download = 'engraving-preview.png';
//     document.body.appendChild(downloadLink);
//     downloadLink.click();
//     document.body.removeChild(downloadLink);
//   })
//   .catch(error => {
//     console.error('Error uploading image:', error);
//   });
// }

// ----------------------------------------- ADD ALL SELECTED STONES DATA IN JSON ----------------------------------------- //
const addSelectedInputInJson = (finalPrice) => {
  Shopify.cosmos_data.price = parseFloat(finalPrice/100).toFixed(2);
  Shopify.cosmos_data.selected_stones = [];
  Shopify.cosmos_data.selected_engraving_images = [];

  step_wrappers.forEach(wrapper => {
    const checkedInputs = Array.from(wrapper.querySelectorAll('input:checked')).filter(input => !/^color-type-\d+$/.test(input.name));

    checkedInputs.forEach($target_inp => {
      var inputid = $target_inp.value, 
          inputname = $target_inp.dataset.variantName,
          inputimage = $target_inp.dataset.variantImage,
          inputqty = $target_inp.closest('.pendant_content_col')?.querySelector('[name="step-qty"]') 
                      ? parseInt($target_inp.closest('.pendant_content_col')?.querySelector('[name="step-qty"]').value) 
                      : 1;

      if (!Array.isArray(Shopify.cosmos_data.selected_stones)) {
        Shopify.cosmos_data.selected_stones = [];
      }

      if ($target_inp.checked) {
          Shopify.cosmos_data.selected_stones.push({
            id: inputid,
            name: inputname,
            image: inputimage,
            quantity: inputqty
          });
          Shopify.cosmos_data.selected_engraving_images.push(inputimage);
      }
    });
  });
}

// ----------------------------------------- CALCULATE TOTAL FINAL PRICE ----------------------------------------- //
const calculateTotalPrice = () => {
  const basePrice = parseFloat(engraving_price.dataset.engravingPrice) || 0;
  let totalAddOnPrice = 0;

  step_wrappers.forEach(wrapper => {
    const checkedInputs = wrapper.querySelectorAll('[data-option-type="product"]:checked');

    checkedInputs.forEach(input => {
      const price = parseFloat(input.dataset.price);
      if (!isNaN(price)) {
        const pendantCol = input.closest('.pendant_content_col'), 
              qtyInput = pendantCol?.querySelector('[name="step-qty"]'), 
              quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        totalAddOnPrice += price * quantity;
      }
    });
  });

  const finalPrice = basePrice + totalAddOnPrice;
  addSelectedInputInJson(finalPrice);

  engraving_price.innerHTML = theme.Currency.formatMoney(finalPrice).replace('.00','');
};

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% COMMON EVENTS %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
// ----------------------------------------- CLOSE ERROR POPUP ----------------------------------------- //
popup_close.forEach(popup_btn => {
  popup_btn.addEventListener('click', (e) => {
    engraving_popup.classList.remove('cosmos_info_popup-active');
    engraving_popup.classList.remove('slot-empty-popup-active');
    engraving_popup.classList.remove('step-confirm-popup-active');
    showErrorPopup('', '', 'none');
  });
});

// ----------------------------------------- EMPTY SLOTS FROM POPUP CLICK ----------------------------------------- //
slot_empty_popup_btn.addEventListener('click', (e) => {
  showErrorPopup('', '', 'none', window.clickedSlot, { replace: true });
});

// ----------------------------------------- START BUTTON ----------------------------------------- //
engraving_btn.addEventListener('click', (e) => {
  const engravingPage = engraving_btn.closest('.pendant_page');
  if (engravingPage) engravingPage.classList.add('is-active');
  engraving_wrapper.classList.add('is-active');
  scrollToView(engraving_wrapper);
});

// ----------------------------------------- PREVIOUS BUTTON ----------------------------------------- //
engraving_prev.addEventListener('click', (e) => {
  handleErrorMessage();

  const currentIndex = getCurrentStepIndex(), currentStep = step_wrappers[currentIndex];
  if (!abandonSteps(currentStep)) return;

  checkout_btn.style.display = 'none';
  engraving_next.style.display = 'block';

  if (currentIndex > 0) {
    showStep(currentIndex - 1);
  } else {
    // === WHEN THE FIRST STEP IS REACHED ===
    const engravingPage = document.querySelector('.pendant_page');
    if (engravingPage) engravingPage.classList.remove('is-active');
    engraving_wrapper.classList.remove('is-active');
    scrollToView(engraving_wrapper);
  }
});

// ----------------------------------------- NEXT BUTTON CLICK EVENT ----------------------------------------- //
engraving_next.addEventListener('click', () => {
  handleErrorMessage();

  const currentIndex = getCurrentStepIndex(), totalSteps = step_wrappers.length, currentStep = step_wrappers[currentIndex];
  if (!validateCurrentStep(currentIndex)) return;

  // === Proceed to Next Step ===
  showStep(currentIndex + 1, true);
});

// ----------------------------------------- SKIP TO NEXT STEP FROM POPUP ----------------------------------------- //
skip_to_next_step.forEach(skip_btn => {
  skip_btn.addEventListener('click', (e) => {
    showErrorPopup('', '', 'none');

    const currentIndex = getCurrentStepIndex(), totalSteps = step_wrappers.length, currentStep = step_wrappers[currentIndex];
    if (currentIndex === totalSteps - 1) {
      checkout_btn.classList.add('btn--loading');
      generateImagePreview();
      return;
    }
    
    // === Proceed to Next Step ===
    showStep(currentIndex + 1, true);
  });
});

// ----------------------------------------- FINAL ADD TO CART BUTTON EVENT ----------------------------------------- //
checkout_btn.addEventListener('click', (e) => {
  e.preventDefault();

  const currentIndex = getCurrentStepIndex(), totalSteps = step_wrappers.length, currentStep = step_wrappers[currentIndex];
  if (!validateCurrentStep(currentIndex)) return;

  const checkboxes = currentStep.querySelectorAll('input[type="checkbox"]'), anyChecked = Array.from(checkboxes).some(chk => chk.checked);
  if (!anyChecked) {
    showErrorPopup('', theme.engraving.no_zodiac_selection);
    engraving_popup.classList.add('step-confirm-popup-active');
    return;
  }

  e.target.classList.add('btn--loading');
  generateImagePreview();
});

// ----------------------------------------- STEP NUMBER CLICK EVENT ----------------------------------------- //
engraving_bar.querySelectorAll('.circle').forEach((circle, index) => {
  const buttons = circle.querySelectorAll('button');
  if (!buttons.length) return;

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const currentIndex = getCurrentStepIndex();
      if (index === currentIndex) return;

      if (index < currentIndex) {
        if (!abandonSteps(step_wrappers[currentIndex])) return;
        showStep(index, true);
        return;
      }

      // === Only allow next step if validation passes ===
      if (index === currentIndex + 1) {
        if (!validateCurrentStep(currentIndex)) return;
        showStep(index, true);
        return;
      }
    });
  });
});

// ----------------------------------------- SHOW MORE BUTTON CLICK EVENT ----------------------------------------- //
step_wrappers.forEach(stp_wrap => {
  stp_wrap.querySelector('[data-more-options]')?.addEventListener('click', (e) => {
    const clickedEl = e.target.closest('[data-more-options]');
    if (!clickedEl) return;

    const more_text = clickedEl.dataset.more, less_text = clickedEl.dataset.less;
    stp_wrap.classList.toggle('show-more-options');
    clickedEl.innerHTML = stp_wrap.classList.contains('show-more-options') ? less_text : more_text;
  });
});

// ----------------------------------------- 'i' ICON CLICK EVENT ----------------------------------------- //
document.querySelectorAll('[data-more-info]').forEach(infoLink => {
  infoLink.addEventListener('click', (e) => {
    e.preventDefault();

    const container = infoLink.closest('.pend_block_more_info');
    if (!container) return;

    const template = container.querySelector('template');
    if (!template) return;

    const htmlContent = template.innerHTML;
    if (popup_desc) popup_desc.innerHTML = htmlContent;

    if (engraving_popup) {
      engraving_popup.style.display = 'block';
      engraving_popup.classList.remove('slot-empty-popup-active');
      engraving_popup.classList.remove('step-confirm-popup-active');
      engraving_popup.classList.add('cosmos_info_popup-active');
    }
  });
});

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% GOLD/SILVER COLOR or PENDANT TYPE EVENT %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
document.querySelectorAll('.pendant_color input[type="radio"]').forEach(input => {
  input.addEventListener('change', function () {
    if (!this.checked) return;

    const selectedColor = this.value,
          selectedInputName = this.dataset.variantName,
          pendantLeftInn = document.querySelector('.pendant_left_inn'), 
          currentLabel = this.closest('label'),
          inputName = this.name; // "pendant-type-1" or "color-type-1"

    // === Get all radios in the same group ===
    const groupRadios = document.querySelectorAll(`.pendant_color input[name="${inputName}"]`);

    // === Remove only the group's color classes from .pendant_left_inn ===
    if (pendantLeftInn) {
      groupRadios.forEach(radio => {
        pendantLeftInn.classList.remove(radio.value);
      });

      pendantLeftInn.classList.add(selectedColor);
    }

    // === Update 'is-active' only in this group ===
    groupRadios.forEach(radio => {
      const label = radio.closest('label');
      if (label) label.classList.remove('is-active');
    });

    if (currentLabel) currentLabel.classList.add('is-active');
    if (inputName.indexOf('color') != -1) Shopify.cosmos_data.selected_color = selectedInputName;
    calculateTotalPrice();
    cosmos_slider?.slideToLoop(0, 300, true);
  });
});

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% ENGRAVING HELPERS %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
// ----------------------------------------- GET THE SLOT WITH ID ----------------------------------------- //
const getSlots = () => Array.from(document.querySelectorAll('[id^="slot-"], [id^="main-slot-"]')).filter(el => /^(slot|main-slot)-\d+$/.test(el.id));

// ----------------------------------------- FILER FILLED SLOTS ----------------------------------------- //
const getFilledSlots = () => getSlots().filter(el => el.classList.contains('icon-fill'));

// ----------------------------------------- FILER BLANK SLOTS ----------------------------------------- //
const getUnfilledSlots = () => getSlots().filter(el => !el.classList.contains('icon-fill'));

// ----------------------------------------- GET THE TEXT BLOCKS ----------------------------------------- //
const getTextBlocks = () => Array.from(document.querySelectorAll('[id^="text-block-"]')).filter(el => /^text-block-\d+$/.test(el.id));

// ----------------------------------------- HANDLE QTY INPUT FOR MULIPLE SELECTS ----------------------------------------- //
const handleQtyInput = ($target, sign) => {
  if ($target.closest('.pendant_content_col').querySelector('[name="step-qty"]')) {
    let inp_val = parseInt($target.closest('.pendant_content_col').querySelector('[name="step-qty"]').value);
    $target.closest('.pendant_content_col').querySelector('[name="step-qty"]').value = sign == 'plus' ? inp_val + 1 : inp_val - 1;
  }
}

// ----------------------------------------- GET MIRROR SLOT ID for RING ----------------------------------------- //
const getMirrorSlotId = (id) => {
  const match = id.match(/^(slot|main-slot)-(\d+)$/);
  if (!match) return null;

  const [_, type, number] = match;
  return type === 'slot' ? `main-slot-${number}` : `slot-${number}`;
}

// ----------------------------------------- UPDATE TEXT BLOCKS BASED ON THE SLOTS FILLED ----------------------------------------- //
const updateTextBlockBySlotId = (slotId, name = '', display = false) => {
  const match = slotId?.match(/\d+$/);
  if (!match) return null;

  const textBlock = document.getElementById(`text-block-${match[0]}`);
  if (!textBlock) return;

  textBlock.querySelector('tspan').innerHTML = name;
  if (display ? textBlock.classList.add('text-active') : textBlock.classList.remove('text-active'));
};

// ----------------------------------------- TEXT X icon CLICK EVENT for Ring ----------------------------------------- //
getTextBlocks().forEach(textBlock => {
  const removeBtn = textBlock.querySelector('.text-remove');
  if (removeBtn) {
    removeBtn.addEventListener('click', function(e){
      e.preventDefault();
      const match = textBlock.id.match(/\d+$/);
      if (!match) return;

      const number = match[0], matchingSlot = allSlots.find(slot => slot.id.endsWith(`-${number}`));

      if (matchingSlot) {
        const event = new CustomEvent('click', {
          bubbles: true,
          cancelable: true,
        });
        matchingSlot.dispatchEvent(event);
      }
    });
  }
});

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
const maybeUncheckInput = ($input, qtyVal = 0) => {
  if (qtyVal <= 0) {
    $input.checked = false;
    $input.parentElement.classList.remove('is-chosen', 'is-active');
  }
};

// -----------------------------------------
// Remove a stone from the given slot, update history, adjust quantity on corresponding input.
// Returns the stone-input element (if found) so you can optionally re-inject.
// -----------------------------------------
const removeStoneFromSlot = (slot) => {
  if (!slot) return nul;

  const useEl = slot.querySelector('use[href^="#cosmos-"]'), 
        match = useEl?.getAttribute('href')?.match(/#cosmos-(\w+)/);
  if (!match) return null;

  const href = match[0], cosmosId = match[1];

  // === remove from history ===
  const revIdx = window.stonePlacementHistory.slice().reverse().findIndex(entry => entry.slotId === slot.id && entry.cosmos_id === href);

  if (revIdx !== -1) {
    const realIndex = window.stonePlacementHistory.length - 1 - revIdx;
    window.stonePlacementHistory.splice(realIndex, 1);
  }

  // === adjust input qty ===
  const inputSelector = `.pendant_content_inn input[value="${cosmosId}"]:not(.step-input)`, 
        $input = document.querySelector(inputSelector);

  if (!$input) {
    console.warn("removeStoneFromSlot: input not found for cosmosId", cosmosId);
  } else {
    const pendantCol = $input.closest('.pendant_content_col'), qtyInput = pendantCol?.querySelector('[name="step-qty"]');
    let qtyVal = parseInt(qtyInput?.value || '0');
    qtyVal = Math.max(0, qtyVal - 1);
    if (qtyInput) {
      qtyInput.value = qtyVal;
    }

    maybeUncheckInput($input, qtyVal);
  }

  // === clear the slot and mirror ===
  clearSlotCosmos(slot);
  const mirrorId = getMirrorSlotId(slot.id);
  if (mirrorId) {
    const mirrorSlot = document.getElementById(mirrorId);
    if (mirrorSlot) clearSlotCosmos(mirrorSlot);
  }

  return $input;
}

// ----------------------------------------- POPUP ERROR ----------------------------------------- //
const showErrorPopup = (title = '', description = '', layout = 'block', clickedSlot = null, options = {}) => {
  if (layout === 'none') {
    engraving_popup.classList.remove('cosmos_info_popup-active', 'slot-empty-popup-active', 'step-confirm-popup-active');
  }
  if (popup_title) popup_title.innerHTML = title;
  if (popup_desc) popup_desc.innerHTML = description;
  if (engraving_popup) engraving_popup.style.display = layout;

  if (clickedSlot) {
    delete window.clickedSlot;

    const replacedInput = removeStoneFromSlot(clickedSlot), 
          activeMultiStep = document.querySelector('[data-step-wrapper][data-type="multi_select"].step-active');
    if (!activeMultiStep) {
      console.warn("showErrorPopup: no activeMultiStep found");
      calculateTotalPrice();
      return;
    }

    const isActiveStep = activeMultiStep.querySelector('.is-active:not(.is-chosen)'), selectedInput = isActiveStep?.querySelector('input:checked') || window.inputQuantityClicked;
    if (selectedInput) {
      clickedSlot.classList.add('active');
      injectStones(selectedInput);
    }

    calculateTotalPrice();
  }
};

// ----------------------------------------- UPDATE BLANK SLOTS ----------------------------------------- //
const updateSlotWithCosmos = (slot, href, svg_class, mirror_slot = '') => {
  if (!slot) return;
  slot.querySelector('[id$="-item"] use')?.setAttribute('href', href);
  slot.classList.add('icon-fill');
  slot.classList.remove('active');
  updateSVGClass(slot, svg_class);
  delete window.inputQuantityClicked;

  // === Track the placement ===
  if (!mirror_slot) {
    window.stonePlacementHistory.push({
      cosmos_id: href,
      slotId: slot.id
    });
  }
};

// ----------------------------------------- INJECT STONES ----------------------------------------- //
const injectStones = ($target_inp) => {
  const cosmos_id = $target_inp.value, cosmos_name = $target_inp.dataset.stoneName;
  if (!cosmos_id) return;

  const href = `#cosmos-${cosmos_id}`, 
        svg_class = $target_inp.dataset.stoneClass, 
        unfilledSlots = getUnfilledSlots();
  unfilledSlots.forEach(el => el.classList.add('glow-on'));

  
  const activeSlot = unfilledSlots.find(el => el.classList.contains('active'));
  if (!activeSlot) {
    handleErrorMessage(cosmos_type === 'cosmos_ring' ? theme.engraving.ring_error : theme.engraving.pendant_error);
    return;
  }
  
  const mirrorId = getMirrorSlotId(activeSlot.id), mirrorSlot = mirrorId ? document.getElementById(mirrorId) : null;
  if (mirrorSlot) updateSlotWithCosmos(mirrorSlot, href, svg_class, 'mirror-slot');
  
  updateSlotWithCosmos(activeSlot, href, svg_class);
  updateTextBlockBySlotId(activeSlot.id, cosmos_name, true); // === Text block update with the cosmos name for RING ===
  handleQtyInput($target_inp, 'plus');

  $target_inp.parentElement.classList.add('is-chosen');
  unfilledSlots.forEach(el => el.classList.remove('glow-on'));
  step_wrappers.forEach(el => el.classList.remove('stone-zoomin-active'));
}

// ----------------------------------------- ELIMINATE STONES ----------------------------------------- //
const eliminateStones = ($target_inp) => {
  const cosmos_id = $target_inp.value;
  getUnfilledSlots().forEach(el => el.classList.remove('glow-on'));
  step_wrappers.forEach(el => el.classList.remove('stone-zoomin-active'));

  $target_inp.parentElement.classList.remove('is-active', 'is-chosen');

  getFilledSlots().forEach(slot => {
    const useEl = slot.querySelector('use[href^="#cosmos-"]');
    const match = useEl?.getAttribute('href')?.match(/#cosmos-([\w-]+)/);
    if (!match || match[1].trim() !== cosmos_id) return;

    clearSlotCosmos(slot);
  });
}

// ----------------------------------------- CLEAR FILLED SLOTS ----------------------------------------- //
const clearSlotCosmos = (slot) => {
  const useEl = slot?.querySelector('use[href^="#cosmos-"]'), 
        match = useEl?.getAttribute('href')?.match(/#cosmos-(\w+)/);
  if (!match) return;

  useEl.removeAttribute('href');
  slot.classList.remove('icon-fill');

  const mirrorId = getMirrorSlotId(slot.id), 
        mirrorSlot = mirrorId ? document.getElementById(mirrorId) : null;
  mirrorSlot?.querySelector('use[href^="#cosmos-"]')?.removeAttribute('href');
  mirrorSlot?.classList.remove('icon-fill');

  updateTextBlockBySlotId(slot.id); // === Text block update with the cosmos name for RING ===
};

// ----------------------------------------- SPOT CLICK EVENT ----------------------------------------- //
allSlots.forEach(slot => {
  slot.addEventListener('click', (e) => {
    handleErrorMessage();

    const clickedSlot = e.currentTarget, 
          match = clickedSlot.id.match(/^(slot|main-slot)-\d+$/);
    if (!match) return;

    const mirrorId = getMirrorSlotId(clickedSlot.id), 
          mirrorSlot = mirrorId ? document.getElementById(mirrorId) : null;

    // === Only if multi-select is active ===
    const activeMultiStep = document.querySelector('[data-step-wrapper][data-type="multi_select"].step-active');
    if (!activeMultiStep) return;

    let isActiveStep = activeMultiStep.querySelector('.is-active:not(.is-chosen)'), 
        selectedInput = isActiveStep?.querySelector('input:checked'), 
        svg_class = selectedInput?.dataset.stoneClass;

    // === CASE 1: Remove existing stone ===
    if (clickedSlot.classList.contains('icon-fill')) {
      if (engraving_popup) {
        window.clickedSlot = clickedSlot;
        engraving_popup.classList.remove('step-confirm-popup-active');
        engraving_popup.classList.remove('cosmos_info_popup-active');
        engraving_popup.classList.add('slot-empty-popup-active');
        if (selectedInput) {
          showErrorPopup('', theme.engraving.replace_slot_confirmation);
        } else {
          showErrorPopup('', theme.engraving.empty_slot_confirmation);
        }
      }
      return;
    }

    // === CASE 2: Inject new stone ===
    allSlots.forEach(s => s.classList.remove('active'));
    clickedSlot.classList.add('active');

    if (!selectedInput && !window.inputQuantityClicked) {
      handleErrorMessage(activeMultiStep.querySelector('.zodiac-icon') ? theme.engraving.selected_sign_spot_error : theme.engraving.selected_spot_error);
      activeMultiStep.classList.add('stone-zoomin-active');
      return;
    }

    if (window.inputQuantityClicked) {
      isActiveStep = window.inputQuantityClicked.closest('.is-active');
      selectedInput = window.inputQuantityClicked;
      svg_class = selectedInput?.dataset.stoneClass;
    }

    const cosmos_id = selectedInput.value, cosmos_name = selectedInput.dataset.stoneName, href = `#cosmos-${cosmos_id}`;

    updateSlotWithCosmos(clickedSlot, href, svg_class);
    if (mirrorSlot) updateSlotWithCosmos(mirrorSlot, href, svg_class, 'mirror-slot');
    updateTextBlockBySlotId(clickedSlot.id, cosmos_name, true); // === Text block update with the cosmos name for RING ===
    handleQtyInput(selectedInput, 'plus'); // === Increase the stone quantity ===

    isActiveStep?.classList.add('is-chosen');
    allSlots.forEach(el => el.classList.remove('glow-on'));
    step_wrappers.forEach(el => el.classList.remove('stone-zoomin-active'));
    calculateTotalPrice();
  });
});

// ----------------------------------------- STONE INPUT CHANGE HANDLER ----------------------------------------- //
all_stone_inputs.forEach(container => {
  const inputs = container.querySelectorAll('input[type="radio"], input[type="checkbox"]'); 
  
  inputs.forEach(input => {
    const pendantCol = input.closest('.pendant_content_col'), 
          qtyBtns = pendantCol.querySelectorAll('.qty-inc'), 
          qtyInput = pendantCol.querySelector('[name="step-qty"]'),
          input_parent_btn = pendantCol.querySelector('.pendant_content-btn'),
          input_close_btn = pendantCol.querySelector('.pend_block_close');

    // ---------------------------- CHECKBOX / RADIO CHANGE HANDLER ---------------------------- //
    input.addEventListener('change', (e) => {
      cosmos_slider?.slideToLoop(0, 300, true);
      delete window.inputQuantityClicked;
      handleErrorMessage();

      const $target = e.target, 
            allInputs = document.querySelectorAll('.pendant_content_inn:not(.pendant_color) input[type="checkbox"]'), 
            selectedCount = Array.from(allInputs).filter(i => i.checked).length;

      if (selectedCount > max_limit) {
        $target.checked = false;
        handleErrorMessage(theme.engraving.spots_error);
        return;
      }

      if ($target.type === 'radio') {
        // === Radio Logic (Center Stone) ===
        container.querySelectorAll('input[type="radio"]').forEach(r => r.parentElement.classList.remove('is-active'));

        if ($target.checked) {
          $target.parentElement.classList.add('is-active');
          const img = $target.parentElement?.querySelector('.stone-icon img')?.getAttribute('src');
          if (img) center_stone.innerHTML = `<img src="${img}" alt="Center stone image">`;
        }
        
        // === Add info text when center stone is selected ===
        if ($target.closest('.pendant_content_col')) {
          const info_wrapper = $target.closest('.pendant_content_col')?.querySelector('.pend_block_more_info'), 
                info_text = info_wrapper?.querySelector('.cosmos-more-info-content');
          if (info_wrapper && info_text) {
            cosmos_stone_info.innerHTML = info_text?.innerHTML;
            cosmos_stone_info.style.display = 'block';
          } else {
            cosmos_stone_info.innerHTML = '';
            cosmos_stone_info.style.display = 'none';
          }
        }

      } else {
        // === Checkbox Logic (Multi Stones) ===
        if ($target.checked) {
          const unplaced = Array.from(allInputs).filter(input =>
            input !== $target &&
            input.checked &&
            input.parentElement.classList.contains('is-active') &&
            !input.parentElement.classList.contains('is-chosen')
          );

          if (unplaced.length > 0) {
            handleErrorMessage($target.parentElement.querySelector('.zodiac-icon') ? theme.engraving.sign_placement_required_error : theme.engraving.placement_required_error);
            return;
          }

          $target.parentElement.classList.add('is-active');
          $target.closest('.step-wrapper.step-active')?.classList.remove('stone-zoomin-active');
          scrollToView(engraving_image);
          
          injectStones($target);
        } else {
          eliminateStones($target);
          if (qtyInput) qtyInput.value = 0;
        }
      }

      calculateTotalPrice();
    });

    // ---------------------------- QTY +/- BUTTON HANDLER ---------------------------- //
    qtyBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        cosmos_slider?.slideToLoop(0, 300, true);

        const isPlus = e.target.classList.contains('plus'), 
              isMinus = e.target.classList.contains('minus'), 
              $target = pendantCol.querySelector('input:checked');

        if (!$target || !qtyInput) return;
        let qty_val = parseInt(qtyInput.value || '0');

        if (isPlus) {
          window.inputQuantityClicked = $target;
          injectStones($target);
        }

        if (isMinus) {
          if (qty_val <= 0) return;

          const cosmos_id = `#cosmos-${$target.value}`;

          // === Find the last placed slot with this cosmos ===
          const lastIndex = window.stonePlacementHistory.slice().reverse().findIndex(entry => entry.cosmos_id === cosmos_id);
          if (lastIndex === -1) return;

          const realIndex = window.stonePlacementHistory.length - 1 - lastIndex, 
                slotInfo = window.stonePlacementHistory[realIndex], 
                slot = document.getElementById(slotInfo.slotId);

          if (slot) {
            clearSlotCosmos(slot);
            window.stonePlacementHistory.splice(realIndex, 1);

            qty_val--;
            qtyInput.value = qty_val;

            if (qty_val === 0) {
              $target.checked = false;
              $target.parentElement.classList.remove('is-chosen', 'is-active');
            }

            maybeUncheckInput($target, qty_val);
            calculateTotalPrice();
          }
        }
      });
    });

    // ---------------------------- CLICK ON CHECKBOX PARENT ---------------------------- //
    // when a user first clicks on the location and then on the engraving/setting they want, the click should add another engraving/setting, rather than resetting all the engraving/setting selections
    // ----------------------------
    input_parent_btn?.addEventListener('click', function(e){
      if (e.target.closest('.pend_block_close')) return;

      e.preventDefault();
      const $input_chk = e.target.classList.contains('pendant_content-btn') 
                      ? e.target.querySelector('input[type="checkbox"]') 
                      : e.target.closest('.pendant_content-btn').querySelector('input[type="checkbox"]');
      if (!$input_chk?.checked) {
        $input_chk.checked = true;
        const changeEvent = new Event('change', { bubbles: true });
        $input_chk?.dispatchEvent(changeEvent);
      } else {
        window.inputQuantityClicked = $input_chk;
        scrollToView(engraving_image);
        injectStones($input_chk);
      }
    });

    // ---------------------------- CHECKBOX CLOSE EVENT ---------------------------- //
    input_close_btn?.addEventListener('click', function(e){
      e.preventDefault();
      const $closest_chk = e.target.closest('.pendant_content-btn')?.querySelector('input[type="checkbox"]');
      if ($closest_chk?.checked) {
        $closest_chk.checked = false;
        const changeEvent = new Event('change', { bubbles: true });
        $closest_chk?.dispatchEvent(changeEvent);
      }
    });
  });
});